import React from 'react'
import navdbg from '../assests/navdbg.png'
import Arrow from '../assests/Arrow.png'
import {Foot} from '../constants/index'
import speak from '../assests/speak.png'
import darow from  '../assests/darow.png'
function Agenda() {
  return (
    <section className='w-full h-[820px] bg-slate-700 relative -z-20 '>
    <div className='w-full h-[500px] bg-slate-700   '>
            <div className='absolute bottom-0 right-0'><img src={navdbg} alt='nav down' className='items-end'/></div>
            <div className='flex flex-row justify-between'>
        <div>           
           <p className='text-[16px] font-semibold pl-10 pt-4 text-white'>GHSO24</p>
            <p className='text-[26px] font-semibold pl-10   text-white'>Agenda</p>
         </div>
         <div className='flex flex-row '>
            <img src={Arrow} alt='arow' className=' pt-10 pr-10'/>
            <img src={speak} alt='log' className='w-[47px] h-[48px] mt-7 mr-6 border border-1 border-white bg-gray-900 rounded-md  focus:outline-none focus:bg-white '/>
         </div>
           
        </div>




<div className='w-full '>
<div className='w-[80%] flex flex-row mx-auto gap-3 pt-5'>
<button className='w-[120px] h-[48px] border border-1 border-white py-2 text-white rounded-md bg-[#AE0243] text-center'>Conference</button>
<button className='w-[120px] h-[48px] border border-1 border-white py-2 text-white rounded-md bg-none text-center'>Masterclass</button>
<button className='w-[120px] h-[48px] border border-1 border-white py-2 text-white rounded-md bg-none text-center'>EU Summit</button>
</div>

</div>

<div className='w-[80%]  flex flex-row mx-auto gap-2 pt-5 relative z-40'>
<button className='w-[111px] h-[36px] border border-1 border-white py-2 text-[#808080] rounded-t-2xl bg-white text-center'>Dec 12</button>
<button className='w-[111px] h-[36px] border border-1 border-white py-2 text-white rounded-t-2xl bg-[#252A49] text-center'>Dec 13</button>
<button className='w-[111px] h-[36px] border border-1 border-white py-2 text-white rounded-t-2xl bg-[#252A49] text-center'>Dec 14</button>
</div>

<div className='w-full'>
<div className='w-[328px] h-[554px]    bg-white mx-auto relative z-20'>
   <div className='w-[265px flex flex-row justify-around pt-8'>
      <div className='w-[74px] h-[36px] text-[#AE0243] font-bold text-[12px]' >10:00 AM 11:20 PM</div>
      <div className='w-[170px] h-[48px] font-bold text-[12px]' ><p>Session 1: Lorem ipsum dolor sit amet, consectetur</p></div>
      <div className='w-[20px] h-[10px] mt-3'><img src={darow} alt='arow'/></div>
   </div>
   <div className='w-[265px flex flex-row justify-around pt-8'>
      <div className='w-[74px] h-[36px] text-[#AE0243] font-bold text-[12px]' >10:00 AM 11:20 PM</div>
      <div className='w-[170px] h-[48px] font-bold text-[12px]' ><p>Session 1: Lorem ipsum dolor sit amet, consectetur</p></div>
      <div className='w-[20px] h-[10px] mt-3'><img src={darow} alt='arow'/></div>
   </div>
   <div className='w-[265px flex flex-row justify-around pt-8'>
      <div className='w-[74px] h-[36px] text-[#AE0243] font-bold text-[12px]' >10:00 AM 11:20 PM</div>
      <div className='w-[170px] h-[48px] font-bold text-[12px]' ><p>Session 1: Lorem ipsum dolor sit amet, consectetur</p></div>
      <div className='w-[20px] h-[10px] mt-3'><img src={darow} alt='arow'/></div>
   </div>
</div>



</div>

</div>












       
    
        <div className='w-full rounded-t-2xl grid grid-cols-5 absolute z-20 bg-white bottom-0 '>
    {
        
      Foot.map((fot,i)=>(
        <div className='w-full h-16 ml-10 bg-white pt-6'>
           <img src={fot.im} alt='footer' className='w-[39px] h-[30px] ml-4'/>
     </div>
      ))  
      
    }
    </div>


    </section>
  )
}

export default Agenda
